import { Map } from 'immutable';

// constants
import { CURRENT_CHAPTER_FETCH } from '../constants/chapterTypes';
import { ORGANIZATION_FETCH } from '../constants/organizationTypes';

// lib
import httpReducer from '../lib/httpReducer';

export default (state = Map(), action) => {
  switch (action.type) {
    case CURRENT_CHAPTER_FETCH:
    case ORGANIZATION_FETCH: return httpReducer(state, action, { entity: 'roundCategory', updateResult: false });
    default: return state;
  }
};
